export default "__VITE_ASSET__Xi2MuSxI__"